let API_ENDPOINT = '##ApiEndpoint##';

const EVENT_HUB_API_URL = '##EventTrackerEndpointUrl##';
const EVENT_HUB_TRACKER_SWITCHER = '##EventTrackerEndpointSwitch##';

try {
    // eslint-disable-next-line no-undef
    const API_URL = System.resolve('api_url');
    if (API_URL) {
        API_ENDPOINT = API_URL;
    }
} catch (e) {
    // DO NOTHING
}

window.RELEASE = Object.freeze({
    API_ENDPOINT,
    EVENT_HUB_API_URL,
    EVENT_HUB_TRACKER_SWITCHER,
});
